import AppItemcategoriesIndex from "./itemCategory.vue";
import AppItemcategoriesList from "./list/list.vue";
import AppItemcategoriesItem from "./item/item.vue";

const routes = [
  {
    path: "/itemCategory",
    component: AppItemcategoriesIndex,
    meta: {
      auth: {
        roles: "itemCategory.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "itemCategory.index",
        component: AppItemcategoriesList,
        meta: {
          auth: {
            roles: "itemCategory.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "itemCategory.create",
        component: AppItemcategoriesItem,
        meta: {
          auth: {
            roles: "itemCategory.create",
            redirect: { name: "itemCategory.index" }
          }
        }
      },
      {
        path: ":id",
        name: "itemCategory.edit",
        component: AppItemcategoriesItem,
        meta: {
          auth: {
            roles: "itemCategory.update",
            redirect: { name: "itemCategory.index" }
          }
        }
      }
    ]
  }
];

export default routes;
